// import { SidebarAppAlert } from "@dashboard/apps/components/AppAlerts/SidebarAppAlert";
// import { useAppsAlert } from "@dashboard/apps/components/AppAlerts/useAppsAlert";
// import { AppPaths } from "@dashboard/apps/urls";
import { useUser } from "@dashboard/auth";
import { categoryListUrl } from "@dashboard/categories/urls";
// import { collectionListUrl } from "@dashboard/collections/urls";
import { configurationMenuUrl } from "@dashboard/configuration";
import { getConfigMenuItemsPermissions } from "@dashboard/configuration/utils";
import { customerListUrl } from "@dashboard/customers/urls";
import { saleListUrl, voucherListUrl } from "@dashboard/discounts/urls";
import { extensionMountPoints } from "@dashboard/extensions/extensionMountPoints";
import { useExtensions } from "@dashboard/extensions/hooks/useExtensions";
// import {
//   extensionsAppSection,
//   extensionsCustomSection,
//   ExtensionsPaths,
//   extensionsPluginSection,
// } from "@dashboard/extensions/urls";
// import { useFlag } from "@dashboard/featureFlags";
// import { giftCardListUrl } from "@dashboard/giftCards/urls";
import { PermissionEnum } from "@dashboard/graphql";
import { ConfigurationIcon } from "@dashboard/icons/Configuration";
import { CustomersIcon } from "@dashboard/icons/Customers";
import { DiscountsIcon } from "@dashboard/icons/Discounts";
import { HomeIcon } from "@dashboard/icons/Home";
// import { MarketplaceIcon } from "@dashboard/icons/Marketplace";
// import ModelingIcon from "@dashboard/icons/Modeling";
import { OrdersIcon } from "@dashboard/icons/Orders";
import { ProductsIcon } from "@dashboard/icons/Products";
// import { TranslationsIcon } from "@dashboard/icons/Translations";
import { commonMessages, sectionNames } from "@dashboard/intl";
// import { pageListPath } from "@dashboard/modeling/urls";
// import { pageTypeListUrl } from "@dashboard/modelTypes/urls";
import { orderDraftListUrl, orderListUrl } from "@dashboard/orders/urls";
import { productListUrl } from "@dashboard/products/urls";
import { quotationListUrl } from "@dashboard/quotations/urls";
import { sampleRequestListUrl } from "@dashboard/sample-requests/urls";
import { vendorListUrl, vendorMyOrdersUrl, vendorOfferingsUrl, vendorPayPalPaymentUrl } from "@dashboard/vendors/urls";
// import { SearchShortcut } from "@dashboard/search/SearchShortcut";
// import { menuListUrl } from "@dashboard/structures/urls";
// import { languageListUrl } from "@dashboard/translations/urls";
import { Box } from "@saleor/macaw-ui-next";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { useIntl } from "react-intl";
import { SidebarMenuItem } from "../types";
// import { mapToExtensionsItems } from "../utils";

export function useMenuStructure() {
  // const { enabled: hasAppAlertsFeatureFlag } = useFlag("app_alerts");
  // const { handleAppsListItemClick, hasNewFailedAttempts } = useAppsAlert(hasAppAlertsFeatureFlag);

  const extensions = useExtensions(extensionMountPoints.NAVIGATION_SIDEBAR);
  const intl = useIntl();
  const { user } = useUser();
  // const { enabled: showExtensions } = useFlag("extensions");

  // const appExtensionsHeaderItem: SidebarMenuItem = {
  //   id: "extensions",
  //   label: intl.formatMessage(sectionNames.appExtensions),
  //   type: "divider",
  //   paddingY: 1.5,
  // };
  // const getAppSection = (): SidebarMenuItem => ({
  //   icon: renderIcon(<MarketplaceIcon />),
  //   label: intl.formatMessage(sectionNames.apps),
  //   permissions: [],
  //   id: "apps",
  //   url: AppPaths.appListPath,
  //   type: "item",
  //   endAdornment: hasAppAlertsFeatureFlag ? (
  //     <SidebarAppAlert hasNewFailedAttempts={hasNewFailedAttempts} />
  //   ) : null,
  //   onClick: () => handleAppsListItemClick(new Date().toISOString()),
  // });

  // const getExtensionsSection = (): SidebarMenuItem => ({
  //   icon: renderIcon(<MarketplaceIcon />),
  //   label: intl.formatMessage(sectionNames.extensions),
  //   permissions: [],
  //   id: "installed-extensions",
  //   url: ExtensionsPaths.installedExtensions,
  //   type: "itemGroup",
  //   endAdornment: hasAppAlertsFeatureFlag ? (
  //     <SidebarAppAlert hasNewFailedAttempts={hasNewFailedAttempts} />
  //   ) : null,
  //   onClick: () => handleAppsListItemClick(new Date().toISOString()),
  //   children: [
  //     {
  //       label: (
  //         <Box display="flex" alignItems="center" gap={3}>
  //           {intl.formatMessage(sectionNames.installedExtensions)}
  //           {hasAppAlertsFeatureFlag && (
  //             <SidebarAppAlert hasNewFailedAttempts={hasNewFailedAttempts} small />
  //           )}
  //         </Box>
  //       ),
  //       id: "installed-extensions",
  //       url: ExtensionsPaths.installedExtensions,
  //       matchUrls: [
  //         ExtensionsPaths.installedExtensions,
  //         extensionsCustomSection,
  //         extensionsAppSection,
  //         extensionsPluginSection,
  //       ],
  //       permissions: [],
  //       type: "item",
  //     },
  //     {
  //       label: intl.formatMessage(sectionNames.exploreExtensions),
  //       id: "explore-extensions",
  //       url: ExtensionsPaths.exploreExtensions,
  //       permissions: [],
  //       type: "item",
  //     },
  //   ],
  // });

  const menuItems: SidebarMenuItem[] = [
    {
      icon: renderIcon(<HomeIcon />),
      label: intl.formatMessage(sectionNames.home),
      id: "home",
      url: "/",
      type: "item",
    },
    // Conditionally include search menu item only if user is not a vendor
    //  ...(!user?.isVendor ? [{
    //   icon: renderIcon(<SearchIcon />),
    //   label: (
    //     <Box display="flex" alignItems="center" gap={2}>
    //       {intl.formatMessage(sectionNames.search)}
    //       <SearchShortcut />
    //     </Box>
    //   ),
    //   id: "search",
    //   url: "/search",
    //   permissions: [
    //     PermissionEnum.MANAGE_PRODUCTS,
    //     PermissionEnum.MANAGE_PAGES,
    //     PermissionEnum.MANAGE_PAGE_TYPES_AND_ATTRIBUTES,
    //     PermissionEnum.MANAGE_ORDERS,
    //   ],
    //   type: "item",
    // }] as SidebarMenuItem[] : []),
    // Conditionally include catalog menu item only if user is not a vendor
    ...(!user?.isVendor
      ? ([
        {
          children: [
            {
              label: intl.formatMessage(sectionNames.products),
              id: "products",
              url: productListUrl(),
              permissions: [PermissionEnum.MANAGE_PRODUCTS],
              type: "item",
            },
            {
              label: intl.formatMessage(sectionNames.categories),
              id: "categories",
              url: categoryListUrl(),
              permissions: [PermissionEnum.MANAGE_PRODUCTS],
              type: "item",
            },
            // Commented out: Collections menu item
            // {
            //   label: intl.formatMessage(sectionNames.collections),
            //   id: "collections",
            //   url: collectionListUrl(),
            //   permissions: [PermissionEnum.MANAGE_PRODUCTS],
            //   type: "item",
            // },
            // Commented out: Gift Cards menu item
            // {
            //   label: intl.formatMessage(sectionNames.giftCards),
            //   id: "giftCards",
            //   url: giftCardListUrl(),
            //   permissions: [PermissionEnum.MANAGE_GIFT_CARD],
            //   type: "item",
            // },
            // Commented out: Extensions mapping for catalog
            // ...mapToExtensionsItems(
            //   extensions.NAVIGATION_CATALOG,
            //   appExtensionsHeaderItem,
            //   showExtensions,
            // ),
          ],
          icon: renderIcon(<ProductsIcon />),
          url: productListUrl(),
          label: intl.formatMessage(sectionNames.catalog),
          permissions: [PermissionEnum.MANAGE_PRODUCTS], // Removed MANAGE_GIFT_CARD permission
          id: "products",
          type: "itemGroup",
        },
      ] as SidebarMenuItem[])
      : []),
    ...(!user?.isVendor
      ? ([
        {
          children: [
            {
              label: intl.formatMessage(sectionNames.orders),
              permissions: [PermissionEnum.MANAGE_ORDERS],
              id: "orders",
              url: orderListUrl(),
              type: "item",
            },
            // {
            //   label: intl.formatMessage(sectionNames.draftOrders),
            //   permissions: [PermissionEnum.MANAGE_ORDERS],
            //   id: "order-drafts",
            //   url: orderDraftListUrl(),
            //   type: "item",
            // },
            // Commented out: Extensions mapping for orders
            // ...mapToExtensionsItems(
            //   extensions.NAVIGATION_ORDERS,
            //   appExtensionsHeaderItem,
            //   showExtensions,
            // ),
          ],
          icon: renderIcon(<OrdersIcon />),
          label: intl.formatMessage(sectionNames.fulfillment),
          permissions: [PermissionEnum.MANAGE_ORDERS],
          id: "orders",
          url: orderListUrl(),
          type: "itemGroup",
        },
      ] as SidebarMenuItem[])
      : []),

    // New: Vendor-only My Orders group
    ...(user?.isVendor
      ? ([
        {
          children: [
            {
              label: intl.formatMessage({ id: 'ZHYSe9', defaultMessage: "All Orders" }),
              id: "vendor-my-orders-all",
              url: vendorMyOrdersUrl(),
              type: "item",
            },
          ],
          icon: renderIcon(<OrdersIcon />),
          label: intl.formatMessage({ id: 'xBOeUs', defaultMessage: "My Orders" }),
          id: "vendor-my-orders",
          url: vendorMyOrdersUrl(),
          type: "itemGroup",
        },
      ] as SidebarMenuItem[])
      : []),

    // {
    //   children: [
    //     {
    //       label: intl.formatMessage(sectionNames.orders),
    //       permissions: [PermissionEnum.MANAGE_ORDERS],
    //       id: "orders",
    //       url: orderListUrl(),
    //       type: "item",
    //     },
    //     {
    //       label: intl.formatMessage(sectionNames.draftOrders),
    //       permissions: [PermissionEnum.MANAGE_ORDERS],
    //       id: "order-drafts",
    //       url: orderDraftListUrl(),
    //       type: "item",
    //     },
    //     // Commented out: Extensions mapping for orders
    //     // ...mapToExtensionsItems(
    //     //   extensions.NAVIGATION_ORDERS,
    //     //   appExtensionsHeaderItem,
    //     //   showExtensions,
    //     // ),
    //   ],
    //   icon: renderIcon(<OrdersIcon />),
    //   label: intl.formatMessage(sectionNames.fulfillment),
    //   permissions: [PermissionEnum.MANAGE_ORDERS],
    //   id: "orders",
    //   url: orderListUrl(),
    //   type: "itemGroup",
    // },
    {
      children: !isEmpty(extensions.NAVIGATION_CUSTOMERS)
        ? [
          {
            label: intl.formatMessage(sectionNames.customers),
            permissions: [PermissionEnum.MANAGE_USERS],
            id: "customers",
            url: customerListUrl(),
            type: "item",
          },
          // Commented out: Extensions mapping for customers
          // ...mapToExtensionsItems(
          //   extensions.NAVIGATION_CUSTOMERS,
          //   appExtensionsHeaderItem,
          //   showExtensions,
          // ),
        ]
        : [
          {
            label: intl.formatMessage(sectionNames.customers),
            permissions: [PermissionEnum.MANAGE_USERS],
            id: "customers",
            url: customerListUrl(),
            type: "item",
          },
        ],
      icon: renderIcon(<CustomersIcon />),
      label: intl.formatMessage(sectionNames.customers),
      permissions: [PermissionEnum.MANAGE_USERS],
      id: "customers",
      url: customerListUrl(),
      type: !isEmpty(extensions.NAVIGATION_CUSTOMERS) ? "itemGroup" : "item",
    },
    // Conditionally include vendors menu items only if user is not a vendor
    ...(!user?.isVendor
      ? ([
        // Add separate Vendors section
        {
          icon: renderIcon(<CustomersIcon />),
          label: intl.formatMessage(sectionNames.vendors),
          permissions: [PermissionEnum.MANAGE_USERS],
          id: "vendors",
          url: vendorListUrl(),
          type: "item",
        },
      ] as SidebarMenuItem[])
      : []),
    {
      children: [
        // {
        //   label: intl.formatMessage(sectionNames.promotions),
        //   id: "promotions",
        //   url: saleListUrl(),
        //   type: "item",
        // },
        // {
        //   label: intl.formatMessage(sectionNames.vouchers),
        //   id: "vouchers",
        //   url: voucherListUrl(),
        //   type: "item",
        // },
        // Commented out: Extensions mapping for discounts
        // ...mapToExtensionsItems(
        //   extensions.NAVIGATION_DISCOUNTS,
        //   appExtensionsHeaderItem,
        //   showExtensions,
        // ),
      ],
      // icon: renderIcon(<DiscountsIcon />),
      // label: intl.formatMessage(commonMessages.discounts),
      // permissions: [PermissionEnum.MANAGE_DISCOUNTS],
      // url: saleListUrl(),
      // id: "discounts",
      // type: "itemGroup",
      icon: renderIcon(<DiscountsIcon />),
      label: intl.formatMessage(sectionNames.vouchers),
      permissions: [PermissionEnum.MANAGE_DISCOUNTS],
      id: "vouchers",
      url: voucherListUrl(),
      type: "item",
    },
    // Commented out: Modeling section
    // {
    //   children: [
    //     {
    //       label: intl.formatMessage(sectionNames.models),
    //       id: "models",
    //       url: pageListPath,
    //       permissions: [PermissionEnum.MANAGE_PRODUCTS],
    //       type: "item",
    //     },
    //     {
    //       label: intl.formatMessage(sectionNames.modelTypes),
    //       id: "model-types",
    //       url: pageTypeListUrl(),
    //       permissions: [
    //         PermissionEnum.MANAGE_PAGES,
    //         PermissionEnum.MANAGE_PAGE_TYPES_AND_ATTRIBUTES,
    //       ],
    //       type: "item",
    //     },
    //     {
    //       label: intl.formatMessage(sectionNames.structures),
    //       id: "structures",
    //       url: menuListUrl(),
    //       permissions: [PermissionEnum.MANAGE_MENUS],
    //       type: "item",
    //     },
    //     ...mapToExtensionsItems(
    //       extensions.NAVIGATION_PAGES,
    //       appExtensionsHeaderItem,
    //       showExtensions,
    //     ),
    //   ],
    //   icon: renderIcon(<ModelingIcon />),
    //   label: intl.formatMessage(sectionNames.modeling),
    //   permissions: [PermissionEnum.MANAGE_PAGES, PermissionEnum.MANAGE_MENUS],
    //   id: "modeling",
    //   url: pageListPath,
    //   type: "itemGroup",
    // },
    // {
    //   children: !isEmpty(extensions.NAVIGATION_TRANSLATIONS)
    //     ? [
    //         // Commented out: Extensions mapping for translations
    //         // ...mapToExtensionsItems(
    //         //   extensions.NAVIGATION_TRANSLATIONS,
    //         //   appExtensionsHeaderItem,
    //         //   showExtensions,
    //         // ),
    //       ]
    //     : undefined,
    //   icon: renderIcon(<TranslationsIcon />),
    //   label: intl.formatMessage(sectionNames.translations),
    //   permissions: [PermissionEnum.MANAGE_TRANSLATIONS],
    //   id: "translations",
    //   url: languageListUrl,
    //   type: !isEmpty(extensions.NAVIGATION_TRANSLATIONS) ? "itemGroup" : "item",
    // },
    // Commented out: Extensions section - always show Apps instead
    // showExtensions ? getExtensionsSection() : getAppSection(),
    // getAppSection(),
    // Add VendorOfferings as main menu item
    ...(user?.isVendor
      ? ([
        {
          icon: renderIcon(<ProductsIcon />),
          label: intl.formatMessage(sectionNames.vendorOfferings),
          permissions: [PermissionEnum.MANAGE_USERS],
          id: "vendor-management",
          url: vendorOfferingsUrl(),
          type: "item",
        },
        {
          icon: renderIcon(<OrdersIcon />), // or create a SampleRequestIcon
          label: intl.formatMessage(sectionNames.sampleRequests),
          permissions: [], // Adjust permissions as needed
          id: "sample-requests",
          url: sampleRequestListUrl(),
          type: "item",
        },
        {
          icon: renderIcon(<CustomersIcon />),
          label: intl.formatMessage({
            id: '874Jjv',
            defaultMessage: "Update Card"
          }),
          permissions: [],
          id: "vendor-paypal-payment",
          url: vendorPayPalPaymentUrl(),
          type: "item",
        },
      ] as SidebarMenuItem[])
      : []),
    {
      icon: renderIcon(<OrdersIcon />), // or create a QuotationsIcon
      label: intl.formatMessage(sectionNames.quotations),
      permissions: [], // Adjust permissions as needed
      id: "quotations",
      url: quotationListUrl(),
      type: "item",
    },
    ...(!user?.isVendor
      ? ([
        {
          icon: renderIcon(<ConfigurationIcon />),
          label: intl.formatMessage(sectionNames.configuration),
          permissions: getConfigMenuItemsPermissions(intl),
          id: "configure",
          url: configurationMenuUrl,
          type: "item",
        },
      ] as SidebarMenuItem[])
      : []),
  ];
  const isMenuItemPermitted = (menuItem: SidebarMenuItem) => {
    const userPermissions = (user?.userPermissions || []).map(permission => permission.code);

    if (!menuItem?.permissions || menuItem?.permissions?.length < 1) {
      return true;
    }

    return menuItem.permissions.some(permission => userPermissions.includes(permission));
  };
  const getFilteredMenuItems = (menuItems: SidebarMenuItem[]) =>
    menuItems.filter(isMenuItemPermitted);

  return menuItems.reduce((resultItems: SidebarMenuItem[], menuItem: SidebarMenuItem) => {
    if (!isMenuItemPermitted(menuItem)) {
      return resultItems;
    }

    const { children } = menuItem;
    const filteredChildren = children ? getFilteredMenuItems(children) : undefined;

    return [...resultItems, { ...menuItem, children: filteredChildren }];
  }, []);
}

function renderIcon(icon: React.ReactNode) {
  return (
    <Box color="default2" __width={20} __height={20}>
      {icon}
    </Box>
  );
}
